// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1FLR1","text":"SelectPayment_text__1ZPR2","title":"SelectPayment_title__3Jakz","btn":"SelectPayment_btn__1VTEb"};